import {connect} from 'react-redux';
import Schedule from './schedule';

export default connect(({usersMap, issuesMap, pushIssues, overviewByTrackers, account, token, curProjectID, notifications, notiCount}) =>
    ({
        usersMap,
        issuesMap,
        pushIssues,
        overviewByTrackers,
        account,
        token,
        curProjectID,
        notifications,
        notiCount
    }))(Schedule);


// WEBPACK FOOTER //
// ./src/components/schedule/index.js